export const getUserGroups = userInfoStores => {
  if (!userInfoStores?.length) return []

  const groupsByName = {}

  userInfoStores.forEach(userStore => {
    const { name, color } = userStore?.group || {}

    if (!groupsByName[name]) {
      groupsByName[name] = { name, color, storeNames: [] }
    }

    if (userStore.name) groupsByName[name].storeNames.push(userStore.name)
  })

  return Object.values(groupsByName)
}
